<template>
  <transition name="fade">
	  <div class="loading_container" v-if="isLoading">
      <scale-loader :loading="isLoading" :color="$vuetify.theme.primary" height="45px" width="7px"></scale-loader>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

export default{
  data: function(){
    return {
      // isLoading : true
    }
  },
  components : {
    'scale-loader' : ScaleLoader
  },
  computed: {
  	...mapGetters({  
  		isLoading : 'isLoading' 
    }),
  },
}
	
</script>

<style>
	.loading_container{
  	position: fixed;
  	z-index: 9999;
  	height: 2em;
  	overflow: show;
  	margin: auto;
  	top: 0;
  	left: 0;
  	bottom: 0;
  	right: 0;
  }

  .loading_container:before {
  	content: '';
  	display: block;
  	position: fixed;
  	top: 0;
  	left: 0;
  	width: 100%;
  	height: 100%;
  	background-color: rgba(255,255,255,0.7);
	}

  .fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }


</style>


// WEBPACK FOOTER //
// src/components/elements/loading.vue